// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_80ad21f8ef--arrow--1Av6w","rotate":"_80ad21f8ef--rotate--2d2uJ"};